import { Form, Formik } from 'formik';
import React, { useCallback, useState, useEffect } from 'react';
import { IoNotificationsOutline } from 'react-icons/io5';
import { PiCaretDown, PiCaretUp } from 'react-icons/pi';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { io } from 'socket.io-client';
import { sideBarData } from 'src/__data__';
import { BASE_URL_SOCKET } from 'src/baseUrl';
import { Modal } from 'src/components';
import Button from 'src/components/button';
import Switchh from 'src/components/switchh';
import TextField from 'src/components/text-field';
import { fetchSetting } from 'src/redux/action/setting.action';
import { CiLock } from 'react-icons/ci';

import {
  checkShift,
  closeShift,
  shiftFailure,
  shiftRequest,
  shiftSuccess,
} from 'src/redux/action/shifts.action';
import { RootState } from 'src/redux/reducers';
import * as Yup from 'yup';
import NavBar from './NavBar';
import AsideLink from './components/AsideLink';
import { toastAlert } from 'src/utils/toastAlert';

import { Badge, IconButton, Menu as NotifMenu } from '@mui/material';
import moment from 'moment';
import { HiOutlineBell } from 'react-icons/hi';

import { fetchSales, fetchSalesSuccess } from 'src/redux/action/sales.action';
import Service from 'src/setup/network';
import DropDown from './dropDown';
import { SalesButton } from 'src/assets/images';
import { BsArrowLeft } from 'react-icons/bs';
import {
  notificationsUpdate,
  socketConnected,
  unreadCountUpdate,
} from 'src/redux/action/socket.action';
import { ArrowUpRight } from '@phosphor-icons/react';
import { fetchCurrenices, fetchMyCurrency } from 'src/redux/action/currency.action';

interface IProps {
  children?: React.ReactNode;
  title?: any;
  heading?: any;
  icon?: any;
  width?: string | number;
}

const FORM_VALIDATION = Yup.object().shape({
  cash: Yup.number().required('Required').min(0, 'Required'),
});

const DashboardLayout: React.FC<IProps> = ({
  children,
  title,
  heading,
  icon,
  width,
}) => {
  const roleItem = window.localStorage.getItem('role');
  const userRole = roleItem ? JSON.parse(roleItem) : null;
  const [hasFetched, setHasFetched] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [sideBarSwitch, setSidebarSwitch] = React.useState<boolean>(false);
  const [toggleDropdowns, setToggleDropdowns] = React.useState<any>(0);
  const [hideSideBar, setHideSideBar] = React.useState<boolean>(
    userRole !== 'admin'
  );
  const [printReport, setPrintReport] = React.useState<boolean>(false);
  const sideBarId = useSelector(({ layoutSetting }) => layoutSetting);
  const dispatch: any = useDispatch();
  const [anchorElNotif, setAnchorElNotif] = useState<any>(null);
  const openNotif = Boolean(anchorElNotif);
  const [currentShiftInfo, setCurrentShiftInfo] = useState<any>(null);
  const [activeDrop, setActiveDrop] = useState<any>('');
  React.useEffect(() => {
    const roleItem = window.localStorage.getItem('role');
    const userRole = roleItem ? JSON.parse(roleItem) : null;

    if (userRole === 'admin') {
      setHideSideBar(false);
    } else {
      setHideSideBar(true);
    }
  }, []);
  const { orderType } = useSelector(({ salesData }: RootState) => salesData);
  const { unReadCount, notFirst, notifications, socket } = useSelector(
    ({ socketData }: RootState) => socketData
  );

  const [isShown, setIsShown] = useState<any>(false);
  const handleMouseEnter = (item: any) => {
    if (!showSideNav) {
      setIsShown(item);
    }
  };

  const handleMouseLeave = () => {
    setIsShown(false);
  };

  const handleDropDown = (id: number) => {
    setToggleDropdowns(id);
  };

  const makeParentActive = (title: string) => {
    setActiveDrop(title);
  };

  useEffect(() => {
    const currentPath = location.pathname;

    const matchedItem = sideBarData.find((item) => {
      if (item.path === currentPath) {
        return true;
      }
      return item.child?.some((child) => child.path === currentPath);
    });

    if (matchedItem) {
      makeParentActive(matchedItem.title);
    }
  }, [location.pathname]);

  const [showCloseShiftModal, setShowCloseShiftModal] =
    useState<boolean>(false);

  const { shiftData } = useSelector(({ shiftData }: RootState) => shiftData);
  const { salesData } = useSelector(({ salesData }: RootState) => salesData);
  const { floors } = salesData;

  React.useEffect(() => {
    if (location.pathname !== '/current-shift-details') {
      dispatch(checkShift());
    }
  }, []);

  React.useEffect(() => {
    if (!shiftData) {
      handleModal();
    }
  }, [shiftData]);

  const { settingData } = useSelector(
    ({ settingData }: RootState) => settingData,
    shallowEqual
  );

  const fetchSettingCallback: any = useCallback(() => {
    if (hasFetched || settingData?.businessInfo?.length > 0) return;
    dispatch(fetchSetting() as any);
    setHasFetched(true);
  }, [dispatch, hasFetched]);

  React.useEffect(() => {
    fetchSettingCallback();
  }, [fetchSettingCallback]);

  const [showSideNav, setShowSideNav] = useState(true);
  const handleShowSideNav = () => {
    setShowSideNav(!showSideNav);
  };

  const handleModal = () => {
    setShowCloseShiftModal(false);
    setCurrentShiftInfo(null);
    setPrintReport(false);
  };

  useEffect(() => {
    if (showCloseShiftModal) {
      const fetchShiftInfo = async () => {
        try {
          const data = await Service.get('/shifts/currentShiftInfo');
          setCurrentShiftInfo(data.data);
        } catch (err: any) {}
      };
      fetchShiftInfo();
      dispatch(fetchSales() as any);
    }
  }, [showCloseShiftModal]);
  
  useEffect(() => {
    dispatch(fetchCurrenices() as any);
    dispatch(fetchMyCurrency() as any);
  }, []);

  const intValues = {
    cash: '',
  };

  React.useEffect(() => {
    if (shiftData) {
      handleModal();
    }
  }, [shiftData]);

  const handleClose = () => {
    setAnchorElNotif(null);
  };

  React.useEffect(() => {
    if (!notFirst) {
      const fetchNotifications = async () => {
        try {
          const data = await Service.get('/notifications/own');
          const unRead = data?.data?.notificationsInfo?.unReadCount;
          const not = data?.data?.notificationsInfo?.notifications;
          dispatch(notificationsUpdate(not));
          dispatch(unreadCountUpdate(unRead));
        } catch (err: any) {}
      };
      fetchNotifications();
    }
  }, [notFirst]);

  React.useEffect(() => {
    const roleInfo = window.localStorage.getItem('userInfo');
    const userInfo = roleInfo ? JSON.parse(roleInfo) : null;

    if (!socket && !notFirst) {
      const soc = io(BASE_URL_SOCKET, {
        reconnection: true,
        reconnectionAttempts: Infinity,
      });

      dispatch(socketConnected(soc));
    }

    if (socket) {
      socket.emit('onlineEmployees', {
        businessId: userInfo?.businessInfo?.id,
        employeeId: userInfo?.userInfo?.id,
      });
      socket.on('ownNotificationsEmit', (res: any) => {
        const a = res.notificationsInfo.unReadCount;
        const b = res.notificationsInfo.notifications;
        // setUnreadCount(a);
        // setNotifications(b);
        dispatch(unreadCountUpdate(a));
        dispatch(notificationsUpdate(b));
      });

      socket.on('salesDashboardDataEmit', (res: any) => {
        dispatch(fetchSalesSuccess(res));
      });
    }
  }, [socket, notFirst]);

  const handleClickNotif = async (event: any) => {
    setAnchorElNotif(event.currentTarget);
    if (unReadCount !== null && unReadCount > 0) {
      try {
        const notificationIds = notifications.map((i: any) => i.id);
        try {
          await Service.put('/notifications/read', {
            notificationIds,
          });
          // setNotFirst(false);
          dispatch(unreadCountUpdate(0));
        } catch (err: any) {}
      } catch (err: any) {}
    }
  };

  const notificationBody = (option: any) => {
    return (
      <div className="w-[377px] h-fit p-3 rounded-2xl border border-[#F1F0F6] mb-3 flex gap-[10px] ">
        <div
          className={`w-[32px] h-[32px] flex justify-center items-center rounded-full ${
            option.isUrgent
              ? 'text-[#E22B41] bg-[#E22B41] bg-opacity-20'
              : 'text-[#4062FF] bg-[#4062FF] bg-opacity-20'
          }`}
        >
          <IoNotificationsOutline size={20} />
        </div>
        <div className="flex  flex-col gap-1">
          <div className="w-[303px]  break-words font-Outfit font-normal text-sm leading-[21px] text-[#2B2B2B]">
            {option.body}
          </div>
          <div className="font-Outfit font-normal text-sm text-[#7F8397]">
            {moment(option.createdAt).format('DD MMMM YYYY, hh:mm A')}
          </div>
        </div>
      </div>
    );
  };

  const adminNotification = () => (
    <div className="flex items-center">
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={openNotif ? 'long-menu' : undefined}
        aria-expanded={openNotif ? 'true' : undefined}
        aria-haspopup="true"
        onClick={(e) => handleClickNotif(e)}
        sx={{
          '& .MuiBadge-badge': {
            color: '#FFFFFF',
            backgroundColor: '#E7302A ',
            width: '15px',
            height: '15px',
            fontSize: '9px',
          },
        }}
      >
        <Badge
          badgeContent={unReadCount}
          sx={{
            '& .MuiBadge-badge': {
              color: '#FFFFFF',
              backgroundColor: '#E7302A',
              border: 'none',
            },
          }}
        >
          <IoNotificationsOutline size={25} color="#2B2B2B" />
        </Badge>
      </IconButton>
      <NotifMenu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorElNotif}
        open={openNotif}
        onClose={() => handleClose()}
        PaperProps={{
          style: {
            width: '409px',
            height: '371px',
            scrollbarWidth: 'thin',
            backgroundColor: '#FFF',
            border: '1px solid #F1F0F6',
            borderRadius: '12px',
            boxShadow: 'none',
            color: 'white',
          },
        }}
      >
        {notifications.length === 0 ? (
          <div className="flex flex-col h-[320px] w-[409px] border  items-center justify-center">
            <HiOutlineBell size={100} color="#2B2B2B" />
            <span className="text-[#2B2B2B] font-Outfit font-semibold text-xl">
              No notifications yet
            </span>
          </div>
        ) : (
          <div className="flex flex-col w-full gap-2 px-4 py-2  ">
            <p className="text-[#2B2B2B] font-Outfit font-semibold text-xl">
              Notifications
            </p>

            <div className="">
              {notifications.map((option: any, ind: any) => (
                <div key={ind}>{notificationBody(option)}</div>
              ))}
            </div>
          </div>
        )}
      </NotifMenu>
    </div>
  );
  const userInfoString: string | null = window.localStorage.getItem('userInfo');
  const userInfo = userInfoString ? JSON.parse(userInfoString) : null;

  const user_role: string | null = userInfo?.role;

  useEffect(() => {}, [hideSideBar]);

  const isdineOpen = ['/dine-in'].includes(location.pathname);
  const isdineinTableSectionOpen = [
    '/table',
    '/table/variants',
    '/open-tickets',
    '/closed-tickets',
    '/payment',
  ].includes(location.pathname);
  if (location.pathname === '/kitchen-display') {
    // Ensure that we always return a valid React element or null
    return <>{children}</>; // React.Fragment is used to wrap children safely
  }
  return (
    <div className="flex flex-wrap overflow-auto transition-all">
      <div
        className={`${
          !hideSideBar
            ? 'h-[calc(100vh-56px)] xl:top-[54px] overflow-scroll fixed'
            : 'h-[100vh]'
        }  flex w-screen`}
      >
        {hideSideBar ? (
          <></>
        ) : (
          <>
            <NavBar
              title={title}
              sideBarSwitch={sideBarSwitch}
              setSidebarSwitch={setSidebarSwitch}
            />
            <div
              className={` ${
                showSideNav ? 'min-w-[241px]' : 'min-w-[70px]'
              } relative bg-light-grey transition-[all] duration-500  h-full border-r border-x-light-gray`}
            >
              <aside
                className={` fixed flex flex-col xl:top-[54px] ${
                  showSideNav ? 'w-[241px]' : 'w-[70px]'
                }  z-[10]   h-[calc(100vh-53px)]  bg-pure-white  shadow left-0  transition-[all]  duration-500`}
              >
                <div
                  onClick={() => {
                    handleMouseLeave();
                    handleShowSideNav();
                  }}
                  className={`transition-all duration-500 flex items-center justify-center w-5 h-5 bg-white rounded-full  z-50  bg-pure-white translate-x-1/2 right-0 top-5 absolute
                ${
                  showSideNav
                    ? ' bg-[linear-gradient(145deg, #ffffff, #e6e6e6)] shadow-[2px_2px_4px_#d9d9d9,-2px_-2px_4px_#ffffff] '
                    : 'rotate-180 bg-pure-white shadow-[inset_-2px_-2px_4px_#d9d9d9,inset_2px_2px_4px_#ffffff]'
                }
                `}
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.76561 9.48465C7.80045 9.51949 7.82809 9.56086 7.84694 9.60638C7.8658 9.6519 7.8755 9.70069 7.8755 9.74996C7.8755 9.79924 7.8658 9.84803 7.84694 9.89355C7.82809 9.93907 7.80045 9.98044 7.76561 10.0153C7.73077 10.0501 7.6894 10.0778 7.64388 10.0966C7.59836 10.1155 7.54957 10.1252 7.5003 10.1252C7.45102 10.1252 7.40223 10.1155 7.35671 10.0966C7.31119 10.0778 7.26982 10.0501 7.23498 10.0153L3.48498 6.26528C3.45012 6.23045 3.42246 6.18909 3.40359 6.14357C3.38471 6.09804 3.375 6.04925 3.375 5.99996C3.375 5.95068 3.38471 5.90189 3.40359 5.85636C3.42246 5.81084 3.45012 5.76948 3.48498 5.73465L7.23498 1.98465C7.30535 1.91429 7.40078 1.87476 7.5003 1.87476C7.59981 1.87476 7.69524 1.91429 7.76561 1.98465C7.83597 2.05502 7.8755 2.15045 7.8755 2.24996C7.8755 2.34948 7.83597 2.44491 7.76561 2.51528L4.28045 5.99996L7.76561 9.48465Z"
                      fill="#2B2B2B"
                    />
                  </svg>
                </div>
                <div className="flex gap-6  flex-col -mb-[calc(50px+43px+5rem)] pb-4 z-40 bg-pure-white shadow-sm">
                  <NavLink
                    to="/"
                    className={`h-[50px] mt-4 flex   items-center gap-4 justify-start `}
                  >
                    <div
                      className={`z-10 bg-pure-white ${
                        showSideNav ? 'pl-6' : 'px-4'
                      }`}
                    >
                      {settingData?.businessInfo?.logo ? (
                        <img
                          src={settingData?.businessInfo?.logo}
                          alt="banner-logo"
                          width="50"
                          height="50"
                          className={`transition-[all] duration-500  bg-pure-white object-contain z-10 rounded-md  `}
                        />
                      ) : (
                        <svg
                          width="50"
                          height="50"
                          viewBox="0 0 50 50"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="50" height="50" rx="5" fill="#F1F0F6" />
                          <path
                            opacity="0.2"
                            d="M37 21V23C37 24.0609 36.5786 25.0783 35.8284 25.8284C35.0783 26.5786 34.0609 27 33 27C31.9391 27 30.9217 26.5786 30.1716 25.8284C29.4214 25.0783 29 24.0609 29 23V21H21V23C21 24.0609 20.5786 25.0783 19.8284 25.8284C19.0783 26.5786 18.0609 27 17 27C15.9391 27 14.9217 26.5786 14.1716 25.8284C13.4214 25.0783 13 24.0609 13 23V21L14.7925 14.725C14.8521 14.5168 14.9776 14.3335 15.1503 14.2027C15.323 14.072 15.5334 14.0009 15.75 14H34.25C34.4672 14 34.6785 14.0708 34.852 14.2016C35.0254 14.3324 35.1515 14.5161 35.2113 14.725L37 21Z"
                            fill="#7F8397"
                          />
                          <path
                            d="M38 21C38.0005 20.907 37.9879 20.8144 37.9625 20.725L36.1688 14.45C36.0482 14.0336 35.7962 13.6675 35.4504 13.4061C35.1045 13.1448 34.6835 13.0023 34.25 13H15.75C15.3165 13.0023 14.8955 13.1448 14.5496 13.4061C14.2038 13.6675 13.9518 14.0336 13.8313 14.45L12.0388 20.725C12.0129 20.8144 11.9999 20.907 12 21V23C12 23.7762 12.1807 24.5418 12.5279 25.2361C12.875 25.9303 13.379 26.5343 14 27V35C14 35.5304 14.2107 36.0391 14.5858 36.4142C14.9609 36.7893 15.4696 37 16 37H34C34.5304 37 35.0391 36.7893 35.4142 36.4142C35.7893 36.0391 36 35.5304 36 35V27C36.621 26.5343 37.125 25.9303 37.4721 25.2361C37.8193 24.5418 38 23.7762 38 23V21ZM15.75 15H34.25L35.6775 20H14.3263L15.75 15ZM22 22H28V23C28 23.7957 27.6839 24.5587 27.1213 25.1213C26.5587 25.6839 25.7957 26 25 26C24.2044 26 23.4413 25.6839 22.8787 25.1213C22.3161 24.5587 22 23.7957 22 23V22ZM20 22V23C20 23.7957 19.6839 24.5587 19.1213 25.1213C18.5587 25.6839 17.7957 26 17 26C16.2044 26 15.4413 25.6839 14.8787 25.1213C14.3161 24.5587 14 23.7957 14 23V22H20ZM34 35H16V27.9C16.3292 27.9664 16.6642 27.9999 17 28C17.7762 28 18.5418 27.8193 19.2361 27.4721C19.9303 27.125 20.5343 26.621 21 26C21.4657 26.621 22.0697 27.125 22.7639 27.4721C23.4582 27.8193 24.2238 28 25 28C25.7762 28 26.5418 27.8193 27.2361 27.4721C27.9303 27.125 28.5343 26.621 29 26C29.4657 26.621 30.0697 27.125 30.7639 27.4721C31.4582 27.8193 32.2238 28 33 28C33.3358 27.9999 33.6708 27.9664 34 27.9V35ZM33 26C32.2044 26 31.4413 25.6839 30.8787 25.1213C30.3161 24.5587 30 23.7957 30 23V22H36V23C36 23.7957 35.6839 24.5587 35.1213 25.1213C34.5587 25.6839 33.7957 26 33 26Z"
                            fill="#7F8397"
                          />
                        </svg>
                      )}
                    </div>
                    <div
                      className={` -z-10 transition-[all]  duration-500 ${
                        !showSideNav &&
                        'absolute translate-x-[-200px] invisible '
                      }`}
                    >
                      <p className={`font-semibold text-base w-max capitalize`}>
                        {settingData?.businessInfo?.name
                          ? settingData?.businessInfo?.name.length <= 16
                            ? settingData?.businessInfo?.name
                            : settingData?.businessInfo?.name.slice(0, 16) +
                              '..'
                          : 'Mero Restaurant'}
                      </p>
                      <p className="text-sm capitalize text-secondary-0 w-max">
                        {user_role}
                      </p>
                    </div>
                  </NavLink>

                  {/* <div
                  className={`min-h-[43px] flex items-center justify-center ${
                    showSideNav ? 'px-6' : 'px-4'
                  } w-full rounded-full  relative`}
                >
                  <div
                    // to="/dine-in"
                    className="inline-block w-full bg-[#4062ff] opacity-50 h-[43px] rounded-md cursor-pointer opacity "
                  >
                    {showSideNav ? (
                      <img
                        src={SalesButton}
                        alt=""
                        className="w-full h-full min-w-full object-contain object-left  rounded-md"
                      />
                    ) : (
                      <div className="bg-[#4062ff]  h-[43px] rounded-md mx-auto px-2 py-3 flex items-center justify-center">
                        <h6 className="text-[white] capitalize w-max text-xs font-bold ">
                          QS
                        </h6>
                      </div>
                    )}
                  </div>
                  <CiLock
                    size={22}
                    className={`opacity-100 absolute z-10   top-3 ${
                      showSideNav ? 'right-6' : 'right-2'
                    } p-1  rounded-full`}
                    color="#fff"
                  />
                </div> */}
                </div>

                <ul
                  className={` pt-[calc(50px+43px+4.85rem)] relative max-w-full  flex flex-col 
                z-30  ${showSideNav && 'overflow-x-hidden '} `}
                >
                  <div
                    className={`py-[0.8rem]  top-0 bg-pure-white w-full   ${
                      showSideNav && 'z-[30]'
                    }`}
                  ></div>

                  {sideBarData.map((item, index) => (
                    <li
                      // className="border-b border-r border-[#edf1f7] "
                      className={`h-max min-h-max mb-6 last:mb-7 `}
                      // key={item?.id}
                      key={index}
                    >
                      <div
                        className={`min-h-max parent-active ${
                          activeDrop === item?.title &&
                          'border-r-[3px] border-r-[rgb(64,98,255)] border-solid'
                        }`}
                      >
                        {item?.hasChild ? (
                          <>
                            <div
                              className="flex items-center flex-nowrap justify-between"
                              onClick={() => {
                                handleDropDown(
                                  toggleDropdowns === Number(item?.id)
                                    ? 123
                                    : Number(item?.id)
                                );
                              }}
                            >
                              <div
                                // to={item?.path ?? ''}
                                className={`relative ${
                                  showSideNav && ' space-x-4 '
                                } flex flex-nowrap w-max items-center text-secondary-0 cursor-pointer
                              
                              `}
                                style={{
                                  fontWeight:
                                    activeDrop === item?.title ? 600 : 400,
                                  color:
                                    activeDrop === item?.title
                                      ? '#4062FF'
                                      : '#7F8397',
                                }}
                                // onClick={() => {
                                //   // handleDropDown(item?.id);
                                //   item?.path
                                //     ? makeParentActive(item?.title)
                                //     : null;
                                // }}
                              >
                                <div
                                  onMouseEnter={() =>
                                    handleMouseEnter(item?.title)
                                  }
                                  onMouseLeave={handleMouseLeave}
                                  className={`pl-6 z-10 w-max bg-pure-white ${
                                    isShown ? 'hover:text-primary' : ''
                                  }`}
                                  onClick={() => {
                                    setIsShown('');
                                    setShowSideNav(true);
                                  }}
                                >
                                  {item?.icon}
                                </div>
                                <h4
                                  className={`text-light-grey font-normal capitalize transition-[all]  duration-500  ${
                                    !showSideNav && 'translate-x-[-200px]'
                                  }`}
                                >
                                  {showSideNav ? (
                                    <p
                                      className={`text-base font-normal active-child 
                                    ${
                                      activeDrop === item?.title &&
                                      'font-semibold text-[#4062FF]'
                                    }`}
                                    >
                                      {item?.title}
                                    </p>
                                  ) : (
                                    ''
                                  )}
                                </h4>

                                {isShown === item?.title && !showSideNav && (
                                  <span className=" capitalize  w-20 absolute top-0  left-[110%] bg-primary text-[white] rounded text-[12px] p-1 z-50">
                                    {item?.title}
                                  </span>
                                )}
                              </div>
                              {showSideNav ? (
                                <div
                                  className={`w-full justify-end flex z-20 transition-[all]  duration-500 ${
                                    !showSideNav &&
                                    'absolute translate-x-[-200px] -z-10  invisible '
                                  }`}
                                >
                                  <PiCaretDown
                                    className={`mr-5 text-secondary-0 ${
                                      toggleDropdowns === item?.id &&
                                      '-rotate-180 text-[#4062FF!important] font-[600!important]'
                                    }	transition-all`}
                                    onClick={() => {
                                      handleDropDown(
                                        toggleDropdowns === Number(item?.id)
                                          ? 123
                                          : Number(item?.id)
                                      );
                                    }}
                                  />
                                </div>
                              ) : (
                                ''
                              )}
                            </div>
                            {item?.hasChild && (
                              <div
                                className={` -z-10 transition-[all]  duration-500 ${
                                  !showSideNav &&
                                  'absolute translate-x-[-200px] invisible '
                                }`}
                              >
                                <div
                                  className={`bg-red-500  ${
                                    !(
                                      toggleDropdowns === item?.id &&
                                      item?.child
                                    ) && 'h-[0!important]'
                                  } overflow-x-visible overflow-y-hidden transition-all duration-500 ease-in-out delay-0 ${
                                    item?.child
                                  }`}
                                  style={{
                                    transition: 'all 0.5s ease',
                                    height: `${
                                      (1.5 + 0.75) * (item?.child?.length || 0)
                                    }rem`, //0.75 is the margin of each child and 1.5 is height of each child
                                  }}
                                >
                                  {item?.child?.map((el: any) =>
                                    !el?.Lock ? (
                                      <NavLink
                                        to={el?.path}
                                        key={el?.id}
                                        className=" text-sm mb-3 px-3  first:mt-3  last:mb-0 block"
                                        style={({ isActive }) => ({
                                          fontWeight: isActive ? 600 : 400,
                                          color: isActive
                                            ? '#4062FF'
                                            : '#949CC0',
                                        })}
                                        onClick={() =>
                                          makeParentActive(item?.title)
                                        }
                                      >
                                        <p className="pl-14 text-base">
                                          {el?.title}
                                        </p>
                                      </NavLink>
                                    ) : (
                                      <div
                                        key={el?.id}
                                        className=" text-sm mb-3 px-3  first:mt-3  last:mb-0 block"
                                      >
                                        <p className="pl-14 text-base text-light-gray flex justify-between items-center ">
                                          {el?.title}
                                          <CiLock size={16} />
                                        </p>
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            )}
                          </>
                        ) : (
                          <AsideLink
                            setShowSideNav={setShowSideNav}
                            showSideNav={showSideNav}
                            id={Number(item?.id)}
                            title={item?.title}
                            icon={item?.icon}
                            path={!item?.Lock ? item?.path ?? '' : ''}
                            setToggleDropdowns={setActiveDrop}
                            toggleDropdowns={activeDrop}
                          />
                        )}{' '}
                      </div>
                    </li>
                  ))}
                </ul>
                <div
                  className={`${
                    showSideNav
                      ? 'bottom-0 left-0 w-full bg-pure-white'
                      : '-rotate-90 left-0 -translate-x-[35%] bottom-16 2xl:-translate-x-[23%] 2xl:bottom-12 2xl:scale-[0.9] w-[90px] 2xl:w-[130px]  '
                  } pb-1 z-30 flex justify-center absolute transition-[all] duration-500`}
                >
                  <svg
                    width="115"
                    height="23"
                    viewBox="0 0 115 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.11427 17.12C3.68227 17.12 3.29027 17.032 2.93827 16.856C2.59427 16.672 2.31827 16.42 2.11027 16.1C1.90227 15.78 1.78627 15.416 1.76227 15.008V13.292C1.78627 12.876 1.90227 12.512 2.11027 12.2C2.32627 11.88 2.60627 11.632 2.95027 11.456C3.30227 11.272 3.69027 11.18 4.11427 11.18C4.63427 11.18 5.10227 11.312 5.51827 11.576C5.94227 11.84 6.27427 12.196 6.51427 12.644C6.75427 13.092 6.87427 13.596 6.87427 14.156C6.87427 14.716 6.75427 15.22 6.51427 15.668C6.27427 16.116 5.94227 16.472 5.51827 16.736C5.10227 16.992 4.63427 17.12 4.11427 17.12ZM3.93427 16.1C4.29427 16.1 4.61027 16.016 4.88227 15.848C5.15427 15.68 5.37027 15.452 5.53027 15.164C5.69027 14.868 5.77027 14.528 5.77027 14.144C5.77027 13.768 5.69027 13.432 5.53027 13.136C5.37027 12.84 5.15427 12.612 4.88227 12.452C4.61027 12.284 4.29827 12.2 3.94627 12.2C3.58627 12.2 3.27027 12.284 2.99827 12.452C2.72627 12.612 2.51427 12.84 2.36227 13.136C2.21027 13.432 2.13427 13.772 2.13427 14.156C2.13427 14.532 2.20627 14.868 2.35027 15.164C2.50227 15.452 2.71427 15.68 2.98627 15.848C3.26627 16.016 3.58227 16.1 3.93427 16.1ZM1.11427 19.388V11.3H2.19427V12.8L1.99027 14.18L2.19427 15.572V19.388H1.11427ZM10.7026 17.12C10.1426 17.12 9.63864 16.988 9.19064 16.724C8.74264 16.46 8.38664 16.104 8.12264 15.656C7.85864 15.2 7.72664 14.692 7.72664 14.132C7.72664 13.58 7.85864 13.084 8.12264 12.644C8.38664 12.196 8.74264 11.84 9.19064 11.576C9.63864 11.312 10.1426 11.18 10.7026 11.18C11.2546 11.18 11.7546 11.312 12.2026 11.576C12.6586 11.832 13.0186 12.184 13.2826 12.632C13.5466 13.08 13.6786 13.58 13.6786 14.132C13.6786 14.692 13.5466 15.2 13.2826 15.656C13.0186 16.104 12.6586 16.46 12.2026 16.724C11.7546 16.988 11.2546 17.12 10.7026 17.12ZM10.7026 16.076C11.0626 16.076 11.3826 15.992 11.6626 15.824C11.9426 15.656 12.1626 15.428 12.3226 15.14C12.4826 14.844 12.5626 14.508 12.5626 14.132C12.5626 13.764 12.4786 13.436 12.3106 13.148C12.1506 12.86 11.9306 12.636 11.6506 12.476C11.3786 12.308 11.0626 12.224 10.7026 12.224C10.3426 12.224 10.0226 12.308 9.74264 12.476C9.46264 12.636 9.24264 12.86 9.08264 13.148C8.92264 13.436 8.84264 13.764 8.84264 14.132C8.84264 14.508 8.92264 14.844 9.08264 15.14C9.24264 15.428 9.46264 15.656 9.74264 15.824C10.0226 15.992 10.3426 16.076 10.7026 16.076ZM16.3635 17L14.1075 11.3H15.2355L16.8675 15.74H16.5075L18.1275 11.3H18.7515L20.3715 15.74H20.0115L21.6435 11.3H22.7715L20.5275 17H19.8915L18.2475 12.692H18.6435L16.9875 17H16.3635ZM26.2074 17.12C25.6394 17.12 25.1274 16.992 24.6714 16.736C24.2154 16.472 23.8554 16.116 23.5914 15.668C23.3274 15.22 23.1954 14.712 23.1954 14.144C23.1954 13.584 23.3234 13.08 23.5794 12.632C23.8434 12.184 24.1954 11.832 24.6354 11.576C25.0834 11.312 25.5834 11.18 26.1354 11.18C26.6634 11.18 27.1274 11.3 27.5274 11.54C27.9354 11.78 28.2514 12.112 28.4754 12.536C28.7074 12.96 28.8234 13.44 28.8234 13.976C28.8234 14.056 28.8194 14.144 28.8114 14.24C28.8034 14.328 28.7874 14.432 28.7634 14.552H23.9514V13.652H28.1874L27.7914 14C27.7914 13.616 27.7234 13.292 27.5874 13.028C27.4514 12.756 27.2594 12.548 27.0114 12.404C26.7634 12.252 26.4634 12.176 26.1114 12.176C25.7434 12.176 25.4194 12.256 25.1394 12.416C24.8594 12.576 24.6434 12.8 24.4914 13.088C24.3394 13.376 24.2634 13.716 24.2634 14.108C24.2634 14.508 24.3434 14.86 24.5034 15.164C24.6634 15.46 24.8914 15.692 25.1874 15.86C25.4834 16.02 25.8234 16.1 26.2074 16.1C26.5274 16.1 26.8194 16.044 27.0834 15.932C27.3554 15.82 27.5874 15.652 27.7794 15.428L28.4754 16.136C28.2034 16.456 27.8674 16.7 27.4674 16.868C27.0754 17.036 26.6554 17.12 26.2074 17.12ZM30.001 17V11.3H31.081V17H30.001ZM31.081 13.748L30.673 13.568C30.673 12.84 30.841 12.26 31.177 11.828C31.513 11.396 31.997 11.18 32.629 11.18C32.917 11.18 33.177 11.232 33.409 11.336C33.641 11.432 33.857 11.596 34.057 11.828L33.349 12.56C33.229 12.432 33.097 12.34 32.953 12.284C32.809 12.228 32.641 12.2 32.449 12.2C32.049 12.2 31.721 12.328 31.465 12.584C31.209 12.84 31.081 13.228 31.081 13.748ZM37.2699 17.12C36.7019 17.12 36.1899 16.992 35.7339 16.736C35.2779 16.472 34.9179 16.116 34.6539 15.668C34.3899 15.22 34.2579 14.712 34.2579 14.144C34.2579 13.584 34.3859 13.08 34.6419 12.632C34.9059 12.184 35.2579 11.832 35.6979 11.576C36.1459 11.312 36.6459 11.18 37.1979 11.18C37.7259 11.18 38.1899 11.3 38.5899 11.54C38.9979 11.78 39.3139 12.112 39.5379 12.536C39.7699 12.96 39.8859 13.44 39.8859 13.976C39.8859 14.056 39.8819 14.144 39.8739 14.24C39.8659 14.328 39.8499 14.432 39.8259 14.552H35.0139V13.652H39.2499L38.8539 14C38.8539 13.616 38.7859 13.292 38.6499 13.028C38.5139 12.756 38.3219 12.548 38.0739 12.404C37.8259 12.252 37.5259 12.176 37.1739 12.176C36.8059 12.176 36.4819 12.256 36.2019 12.416C35.9219 12.576 35.7059 12.8 35.5539 13.088C35.4019 13.376 35.3259 13.716 35.3259 14.108C35.3259 14.508 35.4059 14.86 35.5659 15.164C35.7259 15.46 35.9539 15.692 36.2499 15.86C36.5459 16.02 36.8859 16.1 37.2699 16.1C37.5899 16.1 37.8819 16.044 38.1459 15.932C38.4179 15.82 38.6499 15.652 38.8419 15.428L39.5379 16.136C39.2659 16.456 38.9299 16.7 38.5299 16.868C38.1379 17.036 37.7179 17.12 37.2699 17.12ZM43.4755 17.12C42.9475 17.12 42.4755 16.992 42.0595 16.736C41.6435 16.472 41.3115 16.116 41.0635 15.668C40.8235 15.22 40.7035 14.716 40.7035 14.156C40.7035 13.596 40.8235 13.092 41.0635 12.644C41.3115 12.196 41.6435 11.84 42.0595 11.576C42.4755 11.312 42.9475 11.18 43.4755 11.18C43.8995 11.18 44.2835 11.272 44.6275 11.456C44.9715 11.632 45.2475 11.88 45.4555 12.2C45.6715 12.512 45.7915 12.876 45.8155 13.292V15.008C45.7915 15.416 45.6755 15.78 45.4675 16.1C45.2595 16.42 44.9835 16.672 44.6395 16.856C44.2955 17.032 43.9075 17.12 43.4755 17.12ZM43.6555 16.1C44.0155 16.1 44.3275 16.016 44.5915 15.848C44.8635 15.68 45.0755 15.452 45.2275 15.164C45.3795 14.868 45.4555 14.532 45.4555 14.156C45.4555 13.764 45.3755 13.424 45.2155 13.136C45.0635 12.848 44.8515 12.62 44.5795 12.452C44.3155 12.284 44.0035 12.2 43.6435 12.2C43.2835 12.2 42.9675 12.284 42.6955 12.452C42.4235 12.62 42.2075 12.852 42.0475 13.148C41.8955 13.436 41.8195 13.768 41.8195 14.144C41.8195 14.528 41.8955 14.868 42.0475 15.164C42.2075 15.452 42.4235 15.68 42.6955 15.848C42.9755 16.016 43.2955 16.1 43.6555 16.1ZM46.4755 17H45.3835V15.464L45.5875 14.072L45.3835 12.692V8.432H46.4755V17ZM53.544 17.12C53.112 17.12 52.72 17.032 52.368 16.856C52.024 16.672 51.748 16.42 51.54 16.1C51.332 15.78 51.216 15.416 51.192 15.008V13.292C51.216 12.876 51.332 12.512 51.54 12.2C51.756 11.88 52.036 11.632 52.38 11.456C52.732 11.272 53.12 11.18 53.544 11.18C54.064 11.18 54.532 11.312 54.948 11.576C55.372 11.84 55.704 12.196 55.944 12.644C56.184 13.092 56.304 13.596 56.304 14.156C56.304 14.716 56.184 15.22 55.944 15.668C55.704 16.116 55.372 16.472 54.948 16.736C54.532 16.992 54.064 17.12 53.544 17.12ZM53.364 16.1C53.724 16.1 54.04 16.016 54.312 15.848C54.584 15.68 54.8 15.452 54.96 15.164C55.12 14.868 55.2 14.528 55.2 14.144C55.2 13.768 55.12 13.432 54.96 13.136C54.8 12.84 54.584 12.612 54.312 12.452C54.04 12.284 53.728 12.2 53.376 12.2C53.016 12.2 52.7 12.284 52.428 12.452C52.156 12.612 51.944 12.84 51.792 13.136C51.64 13.432 51.564 13.772 51.564 14.156C51.564 14.532 51.636 14.868 51.78 15.164C51.932 15.452 52.144 15.68 52.416 15.848C52.696 16.016 53.012 16.1 53.364 16.1ZM50.544 17V8.432H51.624V12.692L51.42 14.072L51.624 15.464V17H50.544ZM59.1777 17.048L56.7057 11.3H57.9057L59.7417 15.8H59.3577L61.2897 11.3H62.4897L59.8257 17.048H59.1777ZM57.5457 19.388L59.2257 15.944L59.8257 17.048L58.7457 19.388H57.5457Z"
                      fill="#CACFE3"
                    />
                    <path
                      d="M91.6324 18H89.8431L86.5345 8.88472H88.3154L90.7377 15.7887L93.16 8.88472H94.9409L91.6324 18ZM102.699 13.628V8.88472H104.48V18H102.91V16.9112C102.243 17.7552 101.213 18.2448 99.8966 18.2448C96.7569 18.2448 96.2927 15.3583 96.2927 13.9488V8.88472H98.082V13.3664C98.082 14.7843 98.4449 16.5736 100.386 16.5736C101.652 16.5736 102.699 15.7887 102.699 13.628ZM110.333 18.2448C108.113 18.2448 106.653 17.2235 106.34 15.4427L108.147 15.1641C108.374 16.1179 109.235 16.6918 110.451 16.6918C111.548 16.6918 112.215 16.2191 112.215 15.4258C112.215 14.7337 111.911 14.548 109.767 13.9741C107.412 13.358 106.636 12.7081 106.636 11.3661C106.636 9.71184 108.037 8.63151 110.181 8.63151C112.274 8.63151 113.776 9.68652 113.979 11.307L112.172 11.6362C112.046 10.7669 111.312 10.2267 110.197 10.1845C109.126 10.1423 108.4 10.5812 108.4 11.2733C108.4 11.8809 108.813 12.1173 110.949 12.6574C113.244 13.2482 114.029 13.9488 114.029 15.3583C114.029 17.1644 112.637 18.2448 110.333 18.2448Z"
                      fill="#CACFE3"
                    />
                    <path
                      d="M71.0719 8.64008C74.2117 8.64008 74.6759 11.5266 74.6759 12.9361V18.0001H72.8866V13.5184C72.8866 12.1005 72.5236 10.3112 70.5824 10.3112C69.3164 10.3112 68.2698 11.0961 68.2698 13.2568V18.0001H66.4805V8.88484H68.0588V9.97361C68.7256 9.1296 69.7553 8.64008 71.0719 8.64008Z"
                      fill="#CACFE3"
                    />
                    <mask
                      id="mask0_5965_21156"
                      style={{ maskType: 'alpha' }}
                      maskUnits="userSpaceOnUse"
                      x="76"
                      y="8"
                      width="11"
                      height="11"
                    >
                      <circle
                        cx="81.3417"
                        cy="13.6167"
                        r="4.72644"
                        fill="#D9D9D9"
                      />
                    </mask>
                    <g mask="url(#mask0_5965_21156)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M87.283 13.1106C86.9705 13.4231 86.5331 13.5767 86.0939 13.5284L81.8367 13.0597C81.1519 12.9843 80.6136 12.4394 80.5466 11.7537L80.1383 7.57234C80.0959 7.13877 80.2498 6.70904 80.5579 6.40097L81.8971 5.06173C82.7645 4.19433 84.2501 4.72233 84.3756 5.94259L84.5611 7.74726C84.631 8.42704 85.1641 8.96687 85.8431 9.04507L87.7852 9.26881C88.9955 9.40825 89.5098 10.8838 88.6482 11.7453L87.283 13.1106ZM80.5655 20.8263C80.253 20.5138 80.0993 20.0764 80.1477 19.6372L80.6164 15.38C80.6918 14.6952 81.2367 14.157 81.9224 14.09L86.1038 13.6816C86.5373 13.6392 86.967 13.7932 87.2751 14.1012L88.6143 15.4405C89.4817 16.3079 88.9538 17.7935 87.7335 17.9189L85.9288 18.1044C85.249 18.1743 84.7092 18.7075 84.631 19.3865L84.4073 21.3285C84.2678 22.5389 82.7923 23.0531 81.9308 22.1916L80.5655 20.8263ZM74.0388 13.6912C73.5996 13.6428 73.1622 13.7965 72.8497 14.109L71.4844 15.4742C70.6229 16.3358 71.1372 17.8113 72.3475 17.9508L74.2896 18.1745C74.9685 18.2527 75.5017 18.7925 75.5716 19.4723L75.7571 21.277C75.8825 22.4972 77.3681 23.0252 78.2355 22.1578L79.5748 20.8186C79.8829 20.5105 80.0368 20.0808 79.9944 19.6472L79.5861 15.4659C79.5191 14.7802 78.9808 14.2353 78.296 14.1599L74.0388 13.6912ZM79.5672 6.39325C79.8797 6.70572 80.0333 7.14313 79.985 7.58235L79.5163 11.8395C79.4409 12.5243 78.896 13.0626 78.2103 13.1296L74.0289 13.538C73.5954 13.5803 73.1656 13.4264 72.8576 13.1184L71.5184 11.7791C70.651 10.9117 71.1789 9.42607 72.3992 9.30066L74.2039 9.11512C74.8836 9.04525 75.4235 8.51207 75.5017 7.8331L75.7254 5.89106C75.8649 4.68068 77.3404 4.16645 78.2019 5.02798L79.5672 6.39325Z"
                        fill="#CACFE3"
                      />
                    </g>
                  </svg>
                </div>
              </aside>
            </div>
          </>
        )}
        <div
          className={`duration-500 transition-all z-[1] relative px-8 text-pure-white ${
            isdineOpen
              ? 'w-full'
              : isdineinTableSectionOpen
              ? 'w-[calc(100vw-332px)]'
              : showSideNav
              ? 'lg:w-[calc(100vw-241px)]'
              : 'lg:w-[calc(100vw-70px)]'
          } xl:min-w-[970px] 2xl:min-w-[1125px]`}
          style={{
            backgroundColor:
              window.location.pathname === '/daily-summary' ? '#f9f9f9' : '',
          }}
        >
          <div className="mb-4 flex items-center justify-between h-[62px] px-0 py-4 ">
            <div className="flex space-x-2 item-center justify-center  ">
              <p
                className="text-[black] mt-1"
                onClick={() => window?.history?.go(-1)}
              >
                {icon}
              </p>
              <div className="text-[black] font-bold text-xl pageTitle">
                {heading}
              </div>

              {orderType?.online_order ||
              location.pathname === '/dine-in' ||
              location.pathname === '/online-order' ? (
                <>
                  <div className="flex gap-4">
                    {location.pathname === '/online-order' ? (
                      <>
                        <div
                          className="flex flex-row items-center cursor-pointer text-black"
                          onClick={() => {
                            navigate('/dine-in');
                          }}
                        >
                          <BsArrowLeft fontSize={20} />
                        </div>
                      </>
                    ) : (
                      ''
                    )}
                    {/* <div
                      className={`border w-[135px] cursor-pointer h-[33px] rounded-xl   flex gap-[6px] items-center justify-center font-Outfit font-semibold  text-sm hover:text-[#4062FF] hover:border-[#4062FF] ${
                        location.pathname === '/online-order'
                          ? 'border-[#4062FF] text-[#4062FF]'
                          : 'text-[#7F8397] border-[#CACFE3] '
                      }`}
                      onClickCapture={() => {
                        navigate('/online-order');
                      }}
                    >
                      Online Order
                    </div> */}
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
            <div className="text-black  flex justify-end items-center gap-4">
              {
                <Button
                  onClick={() => {
                    navigate('/login', { state: { switchAccount: true } });
                  }}
                  text={'Switch Account'}
                />
              }
              {
                <Button
                  onClick={() => {
                    let url = 'kitchen-display-sales';
                    if (userRole === 'admin') url = 'kitchen-display';
                    window.open(url, '_blank');
                  }}
                  text={
                    <div className="flex gap-1 items-center">
                      <span>KDS</span>
                      <ArrowUpRight />
                    </div>
                  }
                />
              }
              {adminNotification()}
              <div className="flex gap-[0.625rem] items-center">
                <div className="flex gap-[0.625rem] items-center">
                  <p className="">
                    {settingData?.adminInfo?.image ? (
                      <img
                        src={settingData?.adminInfo?.image}
                        alt=""
                        className="w-8 h-8 object-cover object-top rounded-full"
                      />
                    ) : (
                      <span className=" capitalize w-8 h-8 rounded-full bg-[black] text-[white]  text-xl   flex items-center justify-center">
                        {settingData?.adminInfo?.name[0]}
                      </span>
                    )}
                  </p>
                  <p className="font-bold">
                    {settingData?.adminInfo?.name.length > 10
                      ? settingData?.adminInfo?.name.substring(0, 10) + `..`
                      : settingData?.adminInfo?.name}
                  </p>
                </div>
                <DropDown />
              </div>
            </div>
          </div>
          <div className="w-full flex relative h-[calc(100vh-56px-78px)]">
            {' '}
            {/* 56px is navbar and 76px is header */}
            <div
              className={`pr-0 w-${
                width ? width : hideSideBar ? 'full' : '[60%]'
              }`}
              id="dashboardPage"
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(DashboardLayout);
